(function() {
  'use strict';

  var API_BASE = 'https://fitment-api.oempartsdepartment.com';
  var STORAGE_KEY = 'oem_garage_vehicle';
  var FITMENT_KEY = 'oem_fitment_vehicle';

  function saveGarage(vehicle) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
    localStorage.setItem(FITMENT_KEY, JSON.stringify(vehicle));
    window.__oemGarage = vehicle;
    window.dispatchEvent(new CustomEvent('oemVehicleSelected', { detail: { vehicle: vehicle } }));
  }

  function loadGarage() {
    try {
      // Read fitment key first (parts page writes here),
      // then garage key as fallback (widget writes both).
      // Keep both keys in sync so every page reads the same vehicle.
      var f = localStorage.getItem(FITMENT_KEY);
      var g = localStorage.getItem(STORAGE_KEY);
      var primary = f || g;
      if (primary) {
        var parsed = JSON.parse(primary);
        // Sync the other key so they stay consistent
        if (f && !g) localStorage.setItem(STORAGE_KEY, f);
        if (g && !f) localStorage.setItem(FITMENT_KEY, g);
        // If both exist but differ, fitment key wins (most recently set by parts page)
        if (f && g && f !== g) localStorage.setItem(STORAGE_KEY, f);
        return parsed;
      }
    } catch(e) {}
    return null;
  }

  function clearGarage() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(FITMENT_KEY);
    window.__oemGarage = null;
    window.dispatchEvent(new CustomEvent('oemVehicleCleared'));
    updateFitmentBadge(null);
    updateGalleryContext(null);
  }

  function getVehicleName(v) {
    var parts = [v.year, v.make, v.model];
    if (v.sub_model) parts.push(v.sub_model);
    return parts.join(' ');
  }

  function updateFitmentBadge(vehicle, fits) {
    var badge = document.getElementById('oem-inline-fitment');
    if (!badge) return;
    if (!vehicle) {
      badge.innerHTML = '';
      return;
    }
    var label = getVehicleName(vehicle);
    if (fits) {
      badge.innerHTML = '<div style="display:flex;align-items:center;gap:6px;padding:6px 10px;background:#e8f5e9;border-radius:4px;color:#2e7d32;font-weight:600;font-size:0.9rem;">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span>&#10003; Fits your ' + label + '</span></div>';
    } else {
      badge.innerHTML = '<div style="display:flex;align-items:center;gap:6px;padding:6px 10px;background:#fbe9e7;border-radius:4px;color:#c62828;font-weight:600;font-size:0.9rem;">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c62828" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '<span>&#10007; Does not fit your ' + label + '</span></div>';
    }
  }

  function updateGalleryContext() {}

  async function checkProductFitment(vehicle) {
    var badge = document.getElementById('oem-inline-fitment');
    var sku = null;

    if (badge) {
      sku = badge.dataset.sku;
      if (badge.dataset.universal === 'true') {
        badge.innerHTML = '<div style="display:flex;align-items:center;gap:6px;padding:6px 10px;background:#e8f5e9;border-radius:4px;color:#2e7d32;font-weight:600;font-size:0.9rem;">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span>&#10003; Universal Fit</span></div>';
        updateGalleryContext(getVehicleName(vehicle), true);
        return;
      }
    }

    if (!sku) {
      var skuEl = document.querySelector('[data-product-sku]');
      if (skuEl) sku = skuEl.dataset.productSku;
    }
    if (!sku) {
      var skuText = document.querySelector('.product__sku-value, [class*="sku"]');
      if (skuText) sku = skuText.textContent.trim();
    }
    if (!sku) return;

    if (badge) badge.innerHTML = '<div style="padding:6px 10px;color:#666;font-size:0.9rem;">Checking fitment...</div>';

    try {
      var res = await fetch(API_BASE + '/fitment/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          year: vehicle.year,
          make: vehicle.make,
          model: vehicle.model,
          sub_model: vehicle.sub_model || undefined,
          skus: [sku]
        })
      });
      var data = await res.json();
      var valid = data.results && data.results[0] ? data.results[0].valid : false;
      updateFitmentBadge(vehicle, valid);
      updateGalleryContext(getVehicleName(vehicle), valid);
    } catch(e) {
      console.error('Product fitment check error:', e);
    }
  }

  async function getYears() {
    var res  = await fetch(API_BASE + '/fitment/years');
    var data = await res.json();
    return data.years || [];
  }

  async function getMakes(year) {
    var res  = await fetch(API_BASE + '/fitment/makes?year=' + encodeURIComponent(year));
    var data = await res.json();
    return data.makes || [];
  }

  async function getModels(year, make) {
    var res  = await fetch(API_BASE + '/fitment/models?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make));
    var data = await res.json();
    return data.models || [];
  }

  async function validateSku(sku, vehicle) {
    var res  = await fetch(API_BASE + '/fitment/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        year:      vehicle.year,
        make:      vehicle.make,
        model:     vehicle.model,
        sub_model: vehicle.sub_model,
        skus:      [sku]
      })
    });
    var data = await res.json();
    return data.results && data.results[0] ? data.results[0].valid : false;
  }

  var updatingCards = false;

  function updateCollectionCards(validSkus) {
    updatingCards = true;
    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length) { updatingCards = false; return; }
    var shown = 0;
    var total = 0;
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      var listItem = card.closest('li') || card.parentElement;
      var badge = card.querySelector('.fitment-card-badge');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'fitment-card-badge';
        var mediaEl = card.querySelector('.card__media');
        if (mediaEl) mediaEl.style.position = 'relative';
        (mediaEl || card).appendChild(badge);
      }
      if (validSkus === null) {
        badge.style.display = 'none';
        if (listItem) listItem.style.display = '';
      } else {
        total++;
        if (validSkus.indexOf(sku) !== -1) {
          shown++;
          badge.style.display = 'flex';
          badge.className = 'fitment-card-badge fitment-card-badge--fits';
          badge.innerHTML = '&#10003; Fits';
          if (listItem) listItem.style.display = '';
        } else {
          badge.style.display = 'none';
          if (listItem) listItem.style.display = 'none';
        }
      }
    });
    updateFilterBanner(validSkus, shown, total);
    setTimeout(function() { updatingCards = false; }, 50);
  }

  function updateFilterBanner(validSkus, shown, total) {
    var banner = document.getElementById('oem-vehicle-filter-banner');
    if (!banner) {
      var container = document.querySelector('product-list') ||
                      document.querySelector('#product-grid') ||
                      document.querySelector('.collection');
      if (!container) return;
      banner = document.createElement('div');
      banner.id = 'oem-vehicle-filter-banner';
      container.parentNode.insertBefore(banner, container);
    }
    if (validSkus === null) {
      banner.style.display = 'none';
      return;
    }
    var vehicle = loadGarage();
    if (!vehicle) { banner.style.display = 'none'; return; }
    var name = getVehicleName(vehicle);
    banner.style.cssText = 'display:flex;align-items:center;gap:8px;padding:10px 16px;margin-bottom:12px;background:#e3f2fd;border-radius:6px;color:#1565c0;font-weight:600;font-size:0.95rem;';
    banner.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1565c0" stroke-width="2.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
      '<span>Showing ' + shown + ' of ' + total + ' products that fit your <strong>' + name + '</strong></span>';
  }

  async function checkCollectionFitment(vehicle) {
    // Skip if the accessories API has taken over the page
    if (document.getElementById('oem-acc-api')) return;

    var cards = document.querySelectorAll('[data-product-sku]');
    if (!cards.length) return;

    var skus = [];
    cards.forEach(function(card) {
      var sku = card.dataset.productSku;
      if (sku && skus.indexOf(sku) === -1) skus.push(sku);
    });
    if (!skus.length) return;

    try {
      var res = await fetch(API_BASE + '/fitment/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          year: vehicle.year,
          make: vehicle.make,
          model: vehicle.model,
          sub_model: vehicle.sub_model || undefined,
          skus: skus
        })
      });
      var data = await res.json();
      if (data.results) {
        var validSkus = data.results.filter(function(r) { return r.valid; }).map(function(r) { return r.sku; });
        updateCollectionCards(validSkus);
      }
    } catch(e) {
      console.error('Collection fitment check error:', e);
    }
  }

  var searchDebounce = null;
  var searchObserver = new MutationObserver(function() {
    if (updatingCards) return;
    var vehicle = loadGarage();
    if (!vehicle) return;
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(function() {
      checkCollectionFitment(vehicle);
    }, 300);
  });

  function startSearchObserver() {
    var target = document.querySelector('product-list') ||
                 document.querySelector('#product-grid') ||
                 document.querySelector('.collection');
    if (target) {
      searchObserver.observe(target, { childList: true, subtree: true });
    }
  }

  function interceptSearch() {
    var vehicle = loadGarage();
    if (!vehicle) return;
    var make = vehicle.make;
    document.querySelectorAll('form[action*="/search"]').forEach(function(form) {
      if (form.dataset.oemIntercepted) return;
      form.dataset.oemIntercepted = '1';
      form.addEventListener('submit', function() {
        var input = form.querySelector('input[name="q"]');
        if (!input) return;
        var q = input.value.trim();
        if (q && q.toLowerCase().indexOf(make.toLowerCase()) === -1) {
          input.value = make + ' ' + q;
        }
      });
    });
  }

  var fetchPatched = false;
  function interceptPredictiveSearch() {
    if (fetchPatched) return;
    fetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function(url, opts) {
      var vehicle = loadGarage();
      if (vehicle && typeof url === 'string' && url.indexOf('/search/suggest') !== -1) {
        var parsed = new URL(url, location.origin);
        var q = parsed.searchParams.get('q');
        if (q && q.toLowerCase().indexOf(vehicle.make.toLowerCase()) === -1) {
          parsed.searchParams.set('q', vehicle.make + ' ' + q);
          url = parsed.toString();
        }
      }
      return origFetch.call(this, url, opts);
    };
  }

  var updatingCart = false;

  async function checkCartFitment(vehicle) {
    var badges = document.querySelectorAll('.cart-fitment-badge[data-sku]');
    if (!badges.length) return;
    var skuMap = {};
    badges.forEach(function(b) {
      var sku = b.dataset.sku;
      if (sku) skuMap[sku] = true;
    });
    var skus = Object.keys(skuMap);
    if (!skus.length) return;
    updatingCart = true;
    try {
      var res = await fetch(API_BASE + '/fitment/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          year: vehicle.year, make: vehicle.make,
          model: vehicle.model, sub_model: vehicle.sub_model || undefined,
          skus: skus
        })
      });
      var data = await res.json();
      var validSet = {};
      if (data.results) data.results.forEach(function(r) { if (r.valid) validSet[r.sku] = true; });
      var name = getVehicleName(vehicle);
      badges.forEach(function(b) {
        var sku = b.dataset.sku;
        if (!sku) return;
        if (validSet[sku]) {
          b.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;background:#e8f5e9;border-radius:4px;color:#2e7d32;font-size:0.8rem;font-weight:600;margin-top:4px;">' +
            '&#10003; Fits ' + name + '</span>';
        } else {
          b.innerHTML = '<span style="display:inline-flex;align-items:center;gap:4px;padding:3px 8px;background:#fbe9e7;border-radius:4px;color:#c62828;font-size:0.8rem;font-weight:600;margin-top:4px;">' +
            '&#10007; May not fit ' + name + '</span>';
        }
      });
    } catch(e) {
      console.error('Cart fitment check error:', e);
    }
    setTimeout(function() { updatingCart = false; }, 50);
  }

  function clearCartFitment() {
    document.querySelectorAll('.cart-fitment-badge').forEach(function(b) { b.innerHTML = ''; });
  }

  var cartDebounce = null;
  var cartObserver = new MutationObserver(function() {
    if (updatingCart) return;
    var vehicle = loadGarage();
    if (!vehicle) return;
    clearTimeout(cartDebounce);
    cartDebounce = setTimeout(function() { checkCartFitment(vehicle); }, 300);
  });

  function startCartObserver() {
    var target = document.getElementById('CartDrawer-CartItems');
    if (target) cartObserver.observe(target, { childList: true, subtree: true });
  }

  window.oemFitment = {
    saveGarage:   saveGarage,
    loadGarage:   loadGarage,
    clearGarage:  clearGarage,
    getYears:     getYears,
    getMakes:     getMakes,
    getModels:    getModels,
    validateSku:  validateSku
  };

  window.__oemGarage = loadGarage();
  if (window.__oemGarage) {
    window.dispatchEvent(new CustomEvent('oemVehicleSelected', {
      detail: { vehicle: window.__oemGarage }
    }));
    checkProductFitment(window.__oemGarage);
    checkCollectionFitment(window.__oemGarage);
    checkCartFitment(window.__oemGarage);
    interceptSearch();
    interceptPredictiveSearch();
  }
  startSearchObserver();
  startCartObserver();

  window.addEventListener('oemVehicleSelected', function(e) {
    if (e.detail && e.detail.vehicle) {
      checkProductFitment(e.detail.vehicle);
      checkCollectionFitment(e.detail.vehicle);
      checkCartFitment(e.detail.vehicle);
      interceptSearch();
      interceptPredictiveSearch();
    }
  });

  window.addEventListener('oemVehicleCleared', function() {
    updateFitmentBadge(null);
    updateGalleryContext();
    updateCollectionCards(null);
    clearCartFitment();
  });

  window.dispatchEvent(new CustomEvent('oemFitmentReady'));
})();
